import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash.get';
import Icon from '../Icon';

const Accordion = ({ title, open, children, wrapperProps, titleProps }) => {
  const contentEl = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const arrowClassName = classNames('accordion__icon', {
    'accordion__icon--rotate': !isOpen
  });
  const contentClassName = classNames('accordion__content', {
    'accordion__content--open': isOpen
  });
  const titleClassName = classNames(
    'accordion__button flex-row between-xs middle-xs w-100',
    get(titleProps, 'className')
  );

  const handleOnClick = e => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    // it gets open from props in OnMount cause contentEl does not have scrollHeight when
    // it's building the component, so useState(open) would not work
    setIsOpen(open);
  }, [open]);

  return (
    <div className='accordion' {...wrapperProps}>
      <div
        {...titleProps}
        className={titleClassName}
        onClick={handleOnClick}
        role='presentation'
      >
        {title}
        <Icon variant='arrow-up' className={arrowClassName} />
      </div>
      <div
        ref={contentEl}
        className={contentClassName}
        style={{
          maxHeight: isOpen ? contentEl.current.scrollHeight * 2 : 0,
          overflow: isOpen ? 'visible' : 'hidden'
        }}
      >
        {children}
      </div>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.node,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
  wrapperProps: PropTypes.object,
  titleProps: PropTypes.object
};

export default Accordion;
